<template>
  <div>
    <template v-if="data && data.length > 0">
      <div class="chat-wrap">
        <list v-model="loading" :finished="finished" :finished-text="data.length > 10 ? $t('comment.no_more') : ''" @load="$emit('load-more')"
          :immediate-check="false">
          <div class="comment-list" v-for="(comment, index) in data" :key="index">
            <comment-item :content="comment" @item-click="$emit('comment-click',comment)"
              @item-reply="$emit('comment-reply',comment)" @item-preview-images="previewImages"></comment-item>
          </div>
        </list>
      </div>
    </template>
    <template v-else>
      <div class="no-expert">
        <div class="no-data">
          <div class='img-outer'>
            <img src="@/assets/images/comment/zanwu.png" alt="" />
          </div>
        </div>
        <p class="no-data-title">
          {{$t('comment.no_comment')}}
        </p>
      </div>
    </template>

  </div>
</template>

<script>
  import {
    List,
    ImagePreview,
    Toast
  } from 'vant'

  import http from '@/js/comment/http.js'
  import domain from '@host'
  import zhuan_http from '@/js/comment/zhuan_http.js'
  import domainDownload from '@/js/comment/hostDownload.js'
  import md5 from 'js-md5'
  import pc from '@/js/pc.js'
  import CommentItem from './CommentItem'


  export default {
    components: {
      CommentItem,
      List
    },
    props: {
      data: {
        type: Array,
        require: true,
        default: []
      },
      finished: {
        type: Boolean,
        require: true,
        default: false
      },
    },
    data() {
      return {
        loading: false
      }
    },
    created() {

    },
    computed: {},
    watch: {

    },
    mounted() {},
    destroyed() {

    },
    beforeDestory() {

    },
    methods: {
      setLoadingState(loading) {
        this.loading = loading
      },
      previewImages(images_data) {
        const { images, index } = images_data
            ImagePreview({
              images,
              startPosition: index,
              closeable: true,
            })
      }
    }
  }
</script>

<style scoped>
  .chat-wrap {
    border-top: 1px solid #efefef;
    width: 92%;
    margin: 0 auto;
    border-top: 1px solid #ececec;
    overflow: hidden;
  }

  .comment-list {
    margin-top: 0.68rem;
    position: relative;
    border-bottom: 1px solid #dddddd;
  }

  .no-expert {
    width: 100%;
    height: 8.76rem;
    background: #f4f4f4;
  }

  .no-data {
    text-align: center;
  }

  .no-data img {
    margin-top: 3rem;
    width: 5rem;
  }

  .no-data-title {
    color: #cdcdcd;
    text-align: center;
    font-size: 14px;
    margin-top: 0.5rem;
  }
</style>